import React from 'react';
import { Link } from 'react-router-dom';
import { HomeOutlined } from '@ant-design/icons';
import '../../pages/MemberManagement.css';
import '../../styles/literature-lims.css';

export type LiteratureCrumbItem = { label: string; path?: string };

type LiteratureLimsShellProps = {
  crumbs: LiteratureCrumbItem[];
  title: string;
  subtitle?: string;
  headActions?: React.ReactNode;
  stats?: React.ReactNode;
  children: React.ReactNode;
  /** 附加在根节点上的 class，便于单页微调 */
  rootClassName?: string;
};

/**
 * 文献模块页面壳：与仪表盘 / 成员管理 / 耗材等一致的 LIMS 布局（面包屑、标题区、可选统计卡）。
 */
export const LiteratureLimsShell: React.FC<LiteratureLimsShellProps> = ({
  crumbs,
  title,
  subtitle,
  headActions,
  stats,
  children,
  rootClassName = ''
}) => {
  return (
    <div
      className={`page-container full-height members-lims literature-lims-module ${rootClassName}`.trim()}
    >
      <nav className="mm-crumb" aria-label="breadcrumb">
        <HomeOutlined />
        {crumbs.map((item, idx) => (
          <React.Fragment key={`${item.label}-${idx}`}>
            {idx > 0 ? <span className="mm-crumb-sep">/</span> : null}
            {item.path ? (
              <Link to={item.path}>{item.label}</Link>
            ) : (
              <span>{item.label}</span>
            )}
          </React.Fragment>
        ))}
      </nav>

      <header className="mm-page-head">
        <div>
          <h1 className="mm-title">{title}</h1>
          {subtitle ? <p className="mm-subtitle mb-0">{subtitle}</p> : null}
        </div>
        {headActions ? (
          <div
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              gap: 12,
              alignItems: 'center',
              justifyContent: 'flex-end'
            }}
          >
            {headActions}
          </div>
        ) : null}
      </header>

      {stats}

      {children}
    </div>
  );
};
